export const ATTENDANCE_CONFIG = {
    PRESENT: {
        label: "Present",
        color: "#065F46",
        bg: "#ECFDF5",
        border: "#A7F3D0",
        dot: "#10B981",
        iconName: "solar:check-circle-bold",
        pulse: true,
    },
    ABSENT: {
        label: "Absent",
        color: "#991B1B",
        bg: "#FFF1F2",
        border: "#FECDD3",
        dot: "#F43F5E",
        iconName: "solar:close-circle-bold",
    },
    LATE: {
        label: "Late",
        color: "#92400E",
        bg: "#FFFBEB",
        border: "#FDE68A",
        dot: "#F59E0B",
        iconName: "solar:clock-circle-bold",
    },
    HALFDAY: {
        label: "Half Day",
        color: "#92400E",
        bg: "#FFFBEB",
        border: "#FDE68A",
        dot: "#F59E0B",
        iconName: "solar:clock-circle-bold",
    },
    EARLYLEFT: {
        label: "Early Left",
        color: "#ffffff",
        bg: "#827c78",
        border: "#6b6560",
        dot: "#a09a96",
        iconName: "solar:logout-bold",
    },
    EARLYCOMING: {
        label: "Early Coming",
        color: "#7f1d1d",
        bg: "#fca5a5",
        border: "#f87171",
        dot: "#ef4444",
        iconName: "solar:alarm-bold",
    },
    WITHDRAWN: {
        label: "Withdrawn",
        color: "#5B21B6",   // violet-800
        bg: "#F5F3FF",      // violet-50
        border: "#DDD6FE",  // violet-200
        dot: "#8B5CF6",     // violet-500
        iconName: "solar:arrow-left-circle-bold",
        pulse: false,
    },
    WEEK_OFF: {
        label: "Week Off",
        color: '#004085',
        bg: '#cce5ff',
        border: "#8cc4ff",
        dot: '#004085',
        iconName: "solar:calendar-bold"
    },
    WEEKOFF: {
        label: "Week Off",
        color: '#004085',
        bg: '#cce5ff',
        border: "#8cc4ff",
        dot: '#004085',
        iconName: "solar:calendar-bold"
    },
    HOLIDAY: {
        label: "Holiday",
        color: "#9A3412",
        bg: "#FFF7ED",
        border: "#FED7AA",
        dot: "#F97316",
        iconName: "solar:star-bold",
    },
    NO_ATTENDANCE: {
        label: "No Attendance",
        color: "#991B1B",
        bg: "#FFF1F2",
        border: "#FECDD3",
        dot: "#F43F5E",
        iconName: "solar:close-circle-bold",
    },
    PUNCHRECORDED: {
        label: "Punch Recorded",
        color: "#92400E",
        bg: "#FFFBEB",
        border: "#FDE68A",
        dot: "#F59E0B",
        iconName: "solar:clock-circle-bold",
    },
    ON_LEAVE: {
        label: "On Leave",
        color: "#5B21B6",
        bg: "#F5F3FF",
        border: "#DDD6FE",
        dot: "#8B5CF6",
        iconName: "solar:calendar-mark-bold",
    },
    CANCELAPPROVED: {
        label: "Cancel Approved",
        color: "#10b981",
        bg: "#fefefe",
        border: "#96f8d4",
        dot: "#10b981",
        iconName: "solar:arrow-left-circle-bold",
        pulse: false,
    },
}